import { createAction, props } from '@ngrx/store';
import { CommissionLeadershipSchemeModel } from '@shared/data-access/models';

export const getDetail = createAction(
  '[Leadership Scheme] GET DETAIL',
  props<CommissionLeadershipSchemeModel>()
);
